import {z} from 'zod';

export const LeasingTargetGroupSchema = z.enum(['PRIVATE', 'COMMERCIAL']);
export type LeasingTargetGroup = z.infer<typeof LeasingTargetGroupSchema>;
